import React from "react";
import qubeTurtle from "../images/home/turtleGold.png";
import qubeLightTurtle from "../images/home/turtle.png";

export const ProductSelection = ({selectProduct}) => {
    return <div className={"setupContainer flexRowContainer flexCenter positionRelative"}>
        <div className={"flexColumnContainer flexCenter mb40"}>
            <h2>Select your qube flavor!</h2>
        </div>
        <div className={"flexColumnContainer width-maximum"}>
            <div className={"flexFill flexRowContainer flexAlignCenter"}>
                <div className={"qubeProduct cursorPointer"} onClick={() => selectProduct('qube')}>
                    <img src={qubeTurtle}/>
                </div>
            </div>
            <div className={"flexFill flexCenter"}>
                <div className={"qubeLiteProduct cursorPointer flexRowContainer flexAlignCenter"} onClick={() => selectProduct('qubeLite')}>
                    <img src={qubeLightTurtle}/>
                </div>
            </div>
        </div>
        <div className={"flexColumnContainer width-maximum"}>
            <div className={"flexFill flexCenter"}>

                <div>
                    <strong>qube</strong>
                    <ul>
                        <li>Requires Slack & Zoom</li>
                        <li>Access to advanced messaging features</li>
                    </ul>
                </div>
            </div>
            <div className={"flexFill flexCenter"}>

                <div>
                    <strong>qube lite</strong>
                    <ul>
                        <li>Requires Zoom only</li>
                        <li>Some features are not supported</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
}